import { render, staticRenderFns } from "./SocialButtons.vue?vue&type=template&id=2ff22b8b&"
import script from "./SocialButtons.vue?vue&type=script&lang=js&"
export * from "./SocialButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports